<template>
    <div>
        <v-text-field v-model="item.name" @input="$emit('input', item)" label="Name" :rules="getRules(nameFormatRule, 'name')" counter="100" :dense="dense" :readonly="readonly" />
        <transition-group v-if="!removeEmailAddress" name="list-complete" tag="p">
            <div v-for="(email, i) in item.emailAddresses" class="d-flex flex-nowrap align-center justify-center list-complete-item mr-0" :key="i+'email1'">
                <v-text-field v-model="item.emailAddresses[i]" @input="$emit('input', item)" :rules="i === 0 ? getRules(emailFormatRule, 'emailAddress') : getRules(emailFormatRule)" :label="getLabel('Email',item.emailAddresses,i)" :key="i+'email2'" :dense="dense" :readonly="readonly" :disabled="isEdit && noEditEmailAddress" />
                <v-btn v-if="item.emailAddresses.length !== 1 && !readonly && (!isEdit || !noEditEmailAddress)" text small fab @click="removeItem('emailAddresses', i)" :key="i+'email3'"><v-icon>mdi-close</v-icon></v-btn>
                <v-btn v-if="i === item.emailAddresses.length - 1 && !readonly && (!isEdit || !noEditEmailAddress)" text small fab @click="addItem('emailAddresses', '')" :key="i+'email4'"><v-icon>mdi-plus</v-icon></v-btn>
            </div>
        </transition-group>
        <transition-group name="list-complete" tag="p" :class="{ 'mt-n8': isHover }">
            <div v-for="(phoneNumber, i) in item.phoneNumbers" class="d-flex flex-nowrap align-center justify-center list-complete-item mr-0" :key="i+'phone1'">
                <vue-tel-input-vuetify v-model="item.phoneNumbers[i]" @input="$emit('input', item)" :rules="i === 0 ? getRules(phoneNumberFormatRule, 'phoneNumber') : getRules(phoneNumberFormatRule)" :label="getLabel('Phone Number',item.phoneNumbers,i)" class="width-full-div" :defaultCountry="'AU'" :placeholder="''" :key="i+'phone2'" :dense="dense" :readonly="readonly" />
                <v-btn v-if="item.phoneNumbers.length !== 1 && !readonly" text small fab @click="removeItem('phoneNumbers', i)" :key="i+'phone3'"><v-icon>mdi-close</v-icon></v-btn>
                <v-btn v-if="i === item.phoneNumbers.length - 1 && !readonly" text small fab @click="addItem('phoneNumbers', '')" :key="i+'phone4'"><v-icon>mdi-plus</v-icon></v-btn>
            </div>
        </transition-group>
        <transition-group name="list-complete" tag="p" :class="{ 'mb-n3': isHover }">
            <div v-for="(address, i) in item.addresses" class="d-flex flex-nowrap justify-center list-complete-item mr-0" :key="i+'address1'">
                <address-field v-model="item.addresses[i]" @input="$emit('input', item)" :rules="getRules(addressFormatRule, 'address')" :label="getLabel('Address',item.addresses,i)" :key="i+'address2'" :dense="dense" :readonly="readonly">
                    <template v-slot:default>
                        <v-btn v-if="item.addresses.length !== 1 && !readonly" text small fab @click="removeItem('addresses', i)" :key="i+'address3'"><v-icon>mdi-close</v-icon></v-btn>
                        <v-btn v-if="i === item.addresses.length - 1 && !readonly" text small fab @click="addItem('addresses', {})" :key="i+'address4'"><v-icon>mdi-plus</v-icon></v-btn>
                    </template>
                </address-field>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
    import vuetify from "@/plugins/vuetify";
    import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';

    Vue.use(VueTelInputVuetify, {
        vuetify,
    });

    export default {
        props: [
            'value',
            'rules',
            'nameMaxLength',
            'contactId',
            'isHover',
            'readonly',
            'dense',
            'removeEmailAddress',
            'noEditEmailAddress',
            'isEdit'
        ],

        components: {
            addressField: () => import('../components/AddressField')
        },

        data() {
            return {
                dialog: false,
                item: {},
                name: null,
                nameFormatRule: v => !(v && v.length > 100) || 'Name must be less than 100 characters',
                emailFormatRule: value => {
                    const pattern = /(^$)|(^(?!\.)("([^"\r\\]|\\["\r\\])*"|([-a-zA-Z0-9!#$%&'*+/=?^_`{|}~]|[^.]\.)*)([^.])@[^.<> ,:;"[\]\\@](([^<> .,:;"[\]\\@]|(\.(?!\.)))*[^.<>,: ;"[\]\\@])?$)/
                    return pattern.test(value) || 'Invalid e-mail.'
                },
                phoneNumberFormatRule: value => {
                    const pattern = /(^$)|(^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$)/;
                    return pattern.test(value) || 'Invalid phone number'
                },
                addressFormatRule: null
            };
        },

        methods: {
            getLabel(base, items, index) {
                return base + (items.length > 1 ? ' ' + (index + 1) : '');
            },
            addItem(key, item) {
                this.item[key].push(item);
                this.$emit('input', this.item);
            },
            removeItem(key, index) {
                this.item[key].splice(index, 1);
                this.$emit('input', this.item);
            },
            async load() {
                var response = await axios.get('/api/Contacts/' + this.contactId);
                var data = response.data;
                this.$set(this.item, "emailAddresses", data.contactEmails.map(e => e.emailAddress));
                this.$set(this.item, "phoneNumbers", data.contactPhones.map(e => e.phoneNumber));
                this.$set(this.item, "addresses", data.addresses);
                this.item.name = data.contact.name;
                this.item.id = this.contactId;

                if (typeof this.item.addresses !== "undefined" && this.item.addresses !== null) {
                    this.item.addresses.forEach(e => e.country = data.countries[e.id]);
                }
                this.$emit('input', this.item)
            },
            isObject(value) {
                return typeof value !== "undefined" && value !== null;
            },
            getRules(formatRule, key) {
                var rule = this.isObject(this.rules) ? this.rules[key] : null;
                if (!this.isObject(formatRule) && !this.isObject(rule)) {
                    return [];
                }
                else if (!this.isObject(formatRule) && this.isObject(rule)) {
                    return [rule];
                }
                else if (this.isObject(formatRule) && !this.isObject(rule)) {
                    return [formatRule];
                }
                else {
                    return [formatRule, rule];
                }
            },
            propertyHasChanged(originalItem, newItem, field) {
                return !this.isObject(originalItem) && this.isObject(newItem) || this.isObject(newItem) && JSON.stringify(originalItem[field]) !== JSON.stringify(newItem[field]);
            }
        },

        watch: {
            contactId: {
                immediate: true,
                async handler() {
                    if (this.isObject(this.contactId) && (!this.isObject(this.item) || this.item.contactId !== this.contactId)) {
                        await this.load();
                    }
                    else if (!this.isObject(this.item)) {
                        this.item = {
                            id: this.contactId
                        };
                    }
                    if (!this.isObject(this.item.addresses) || this.item.addresses.length === 0) {
                        this.$set(this.item, "addresses", [{}]);
                    }
                    if (!this.isObject(this.item.emailAddresses) || this.item.emailAddresses.length === 0) {
                        this.$set(this.item, "emailAddresses", [""]);
                    }
                    if (!this.isObject(this.item.phoneNumbers) || this.item.phoneNumbers.length === 0) {
                        this.$set(this.item, "phoneNumbers", [""]);
                    }
                }
            }
        }
    };
</script>
<style scoped>
    .width-full-div {
        width: 100%
    }

    .div-padding-above {
        margin: 14px 0px 0px 0px;
    }

    .list-complete-item {
        transition: all 0.5s;
        display: inline-block;
        margin-right: 10px;
    }

    .list-complete-enter, .list-complete-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }

    .list-complete-leave-active {
        position: absolute;
    }
</style>
